var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-container"},[(_vm.list.length)?_c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('TicketInline',{attrs:{"ticket":_vm.list[_vm.currentIndex][0],"index":_vm.currentIndex}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }